import gql from 'graphql-tag';

import actionTypes from './constants';
import helpers from '../../helpers';
import { api } from '../../network';
import { DEFAULT_GOLF_OPTS } from '../../constants';

// -----------------------------------------------------------------------------
// LOGIN EVENTS
// -----------------------------------------------------------------------------

/* */
export const connect = () => (dispatch) => dispatch({
  type: actionTypes.CONNECT,
});

/* */
export const autoLogin = (email, token, refresh) => (dispatch) => dispatch({
  type: actionTypes.LOGIN_SUCCESS,
  payload: { token, refresh },
});

/* */
export const setUser = (user) => (dispatch) => dispatch({
  type: actionTypes.SET_USER,
  payload: user,
});
/* */
export const logout = (err) => (dispatch) => dispatch({
  type: actionTypes.LOGOUT,
  payload: err,
});

// -----------------------------------------------------------------------------
// ACCOUNT (REST)
// -----------------------------------------------------------------------------

/* */
export const session = (token) => (dispatch) => {
  dispatch({
    type: actionTypes.LOGIN_SUCCESS,
    payload: { token },
  });
  return api.get('session', null, { 'x-session-token': token })
    .then((data) => dispatch({
      type: actionTypes.SET_USER,
      payload: data,
    }))
    .catch((err) => dispatch({
      type: actionTypes.LOGIN_FAILED,
      payload: err.message,
    }));
};

// -----------------------------------------------------------------------------
// ACCOUNT (GRAPHQL)
// -----------------------------------------------------------------------------

/* */
export const setAccount = (client, variables) => (dispatch) => client.mutate({
  mutation: gql`${actionTypes.gql.SET_ACCOUNT}`,
  variables,
})
  .then((res) => res.data)
  .then((data) => ({ account: data.setAccount }))
  .then(({ account }) => {
    const matches = account && account.matches ? helpers.array.toObject(account.matches, 'golfId') : {};
    return dispatch({
      type: actionTypes.LOAD_ACCOUNT,
      payload: {
        ...account,
        matches,
      },
    });
  });

export const setLoginAttempted = (value) => ({
  type: 'SET_LOGIN_ATTEMPTED',
  payload: value,
});

/* */
export const loadAccount = (client, variables, fetchPolicy = 'no-cache') => (dispatch) => client.query({
  query: gql`${actionTypes.gql.GET_ACCOUNT}`,
  fetchPolicy,
  variables,
})
  .then((res) => res.data)
  .then(({ getAccount, getAccountPlayerTypes }) => {
    const matches = getAccount && getAccount.matches ? helpers.array.toObject(getAccount.matches, 'golfId') : {};
    return dispatch({
      type: actionTypes.LOAD_ACCOUNT,
      payload: {
        ...getAccount,
        playerTypes: getAccountPlayerTypes,
        matches,
      },
    });
  })
  .catch((err) => dispatch({
    type: actionTypes.NO_ACCOUNT,
    payload: err.message,
  }));

/* */
export const updateAccount = (payload) => (dispatch) => dispatch({
  type: actionTypes.UPDATE_ACCOUNT,
  payload,
});

/* */
export const noAccount = () => (dispatch) => dispatch({
  type: actionTypes.NO_ACCOUNT,
});

/* */
export const loadActivationData = (payload) => (dispatch) => dispatch({
  type: actionTypes.LOAD_ACTIVATION_DATA,
  payload,
});

// -----------------------------------------------------------------------------
// GOLF
// -----------------------------------------------------------------------------

/* */
export const loadGolf = (client, variables, fetchPolicy = 'no-cache') => (dispatch) => client.query({
  query: gql`${actionTypes.gql.GET_GOLF}`,
  fetchPolicy,
  variables,
})
  .then((res) => res.data)
  .then(({ getGolf }) => ({ golf: getGolf }))
  .then(({ golf }) => {
    if (golf) {
      const payload = helpers.object.deepClone(golf);
      payload.options = DEFAULT_GOLF_OPTS;
      golf.options.forEach((o) => {
        payload.options[o.name] = helpers.string.parseJSON(o.value);
      });
      dispatch({
        type: actionTypes.LOAD_GOLF,
        payload,
      });
    } else {
      dispatch({
        type: actionTypes.NO_GOLF,
      });
    }
    return golf;
  })
  .catch((err) => dispatch({
    type: actionTypes.NO_GOLF,
    payload: err.message,
  }));

/* */
export const noGolf = () => (dispatch) => dispatch({
  type: actionTypes.NO_GOLF,
});

// -----------------------------------------------------------------------------
// NAVIGATION DRAWER
// -----------------------------------------------------------------------------

/* */
export const togglePanelNav = (panel) => (dispatch) => dispatch({
  type: actionTypes.TOGGLE_PANEL_NAV,
  payload: panel,
});

// -----------------------------------------------------------------------------
// GAME CONDITIONS (CACHED)
// -----------------------------------------------------------------------------

/* */
export const getGolfWeather = (client, variables) => (dispatch, getState) => {
  const { app } = getState();
  // Fetch cache first
  if (app.cache && app.cache.weather && app.cache.weather > Date.now()) {
    return Promise.resolve();
  }
  return client.query({
    query: gql`${actionTypes.gql.GET_GOLF_WEATHER}`,
    fetchPolicy: 'no-cache',
    variables,
  })
    .then((res) => res.data)
    .then((data) => dispatch({
      type: actionTypes.GET_GOLF_WEATHER,
      payload: data.getGolfWeather,
    }))
    .catch(() => null);
};

/* */
export const getGolfGameConditions = (client, variables) => (dispatch, getState) => {
  const { app } = getState();
  // Fetch cache first
  if (app.cache && app.cache.weather && app.cache.weather > Date.now()) {
    return Promise.resolve();
  }
  return client.query({
    query: gql`${actionTypes.gql.GET_GOLF_GAME_CONDITIONS}`,
    fetchPolicy: 'no-cache',
    variables,
  })
    .then((res) => res.data)
    .then((data) => data.getGolfGameConditions)
    .then((data) => {
      let informations = null;
      const gameConditions = {};
      if (data && data.forEach) {
        data.forEach((gc) => {
          if (gc.type === 'informations') {
            informations = gc.comment;
          } else {
            if (typeof gameConditions[gc.type] === 'undefined') {
              gameConditions[gc.type] = [];
            }
            gameConditions[gc.type].push(gc);
          }
        });
      }
      dispatch({
        type: actionTypes.GET_GOLF_GAME_CONDITIONS,
        payload: {
          informations,
          gameConditions,
        },
      });
    });
};
